// libraries
import {some, includes} from 'lodash';

// shared
import {parseQueryString} from 'shared/utils';

// hidden form fields
const HIDDEN_QUERY_PARAMETER_KEYS = [
  'eiid', 'rej', 'cpiid', 'token', 'next'
];

export function getHiddenParams() {
  const queryParams = parseQueryString(location.search.slice(1));
  let result = {};

  for (let key in queryParams) {
    if (queryParams.hasOwnProperty(key) && HIDDEN_QUERY_PARAMETER_KEYS.indexOf(key) !== -1) {
      result[key] = queryParams[key];
    }
  }
  return result;
}

// educator email validation
const GENERIC_EMAIL_HOSTS = ['@gmail.com', '@yahoo.com', '@hotmail.com'];

export const invalidEducatorEmail = (email) => {
  return some(GENERIC_EMAIL_HOSTS, (host) => includes(email, host));
};
